import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import * as z from 'zod'
import {BasePayloadSchema} from './base-payload'
import {BreadcrumbSchema} from './breadcrumb'

/**
 * Payload schema for individual resource detail pages.
 */
export const ResourceDetailsPayloadSchema = z.lazy(() =>
  BasePayloadSchema.unwrap().extend({
    breadcrumbLinks: safeOptional(z.array(BreadcrumbSchema)),
    indexPath: z.string().optional(),
  }),
)

export type ResourceDetailsPayload = z.infer<typeof ResourceDetailsPayloadSchema>

export function toResourceDetailsPayload(payload: unknown): ResourceDetailsPayload {
  return ResourceDetailsPayloadSchema.parse(payload)
}
